<template>
  <div class="c-footer">
    <div class="flex-center">
      <div class="cur" @click="jumpPage('use_agreement_copyright')">使用协议和版权申明</div>
      <div style="margin:0 10px;">丨</div>
      <div class="cur" @click="jumpPage('user_privacy_agreement')">用户隐私保护指引</div>
      <div style="margin:0 10px;">丨</div>
      <div class="cur" @click="jumpPage('children_privacy_agreement')">儿童隐私政策</div>
      <div style="margin:0 10px;">丨</div>
      <div>公司全称：{{ componyName }}</div>
      <div class="cur" style="margin:0 10px;" @click="jumpBeian">{{ websiteBeian }}</div>
    </div>
  </div>
</template>

<script>
import { config } from '@/api/config.js'
export default {
  data() {
    return {
        componyName: '',
        websiteBeian: ''
    };
  },
  mounted() {
    this.getInfo()
  },
  methods: {
    getInfo() {
        let param = [
            'company_name',
            'website_beian',
            'special_soundmark_font'
          ]
        config({ key: param }).then(res => {
            if (res.error === 0) {
                this.componyName = res.data.company_name
                this.websiteBeian = res.data.website_beian
                this.addFontFaceRule('specialWord', 'normal', '400', res.data.special_soundmark_font);
            }
        })
    },
    addFontFaceRule(fontName, fontStyle, fontWeight, fontUrl) {  
        const style = document.createElement('style');  
        style.type = 'text/css';  
        const css = `  
            @font-face {  
                font-family: '${fontName}';  
                font-style: ${fontStyle};  
                font-weight: ${fontWeight};  
                src: url('${fontUrl}') format('woff2');  
            }  

            .special-font{ 
                font-size: 6rem !important;
                font-family: 'specialWord';
            }
        `;  
        if (style.styleSheet) {  
            style.styleSheet.cssText = css; // For IE  
        } else {  
            style.appendChild(document.createTextNode(css));  
        }  
        document.head.appendChild(style);  
    },
    jumpPage(val) {
        this.$router.push({ path: '/agreement/info', query: { key: val } })
    },
    jumpBeian() {
        let url = 'https://beian.miit.gov.cn'
        window.open(url)
    }
  }

};
</script>

<style scoped lang="scss">
@import "~@/styles/mixins.scss";
.c-footer {
  height: 100%;
  // background: #00000f;
  text-align: center;
  display: flex;
  // flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #aaa;
}

.flex-center {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}
</style>
